import { DesktopRating, MobileRating } from '@cian/frontend-reviews-components';
import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './NewbuildingOverallRating.css';

export interface INewbuildingOverallRatingProps {
  newbuildingNameFormatted: string;
  value: number;
  reviewCount: number;
}

export const NewbuildingOverallRating: React.FC<INewbuildingOverallRatingProps> = props => {
  const { value, newbuildingNameFormatted, reviewCount } = props;

  return (
    <div
      itemScope
      itemProp="aggregateRating"
      itemType="http://schema.org/AggregateRating"
      data-testid="NewbuildingOverallRating"
      className={style['container']}
    >
      <meta itemProp="itemReviewed" content={newbuildingNameFormatted} />
      <meta itemProp="worstRating" content="1" />
      <meta itemProp="bestRating" content="5" />
      <Responsive phone tablet>
        <MobileRating value={value} withRatingValue reviewCount={reviewCount} />
      </Responsive>
      <Responsive desktop>
        <DesktopRating value={value} withRatingValue reviewCount={reviewCount} />
      </Responsive>
    </div>
  );
};
